<template>
  <div class="m-content" >
    <div v-if="!enterCareerSearch">
      <HeaderBox/>
      <div class="report-content">
        <div class="report-area">
          <p>你选取的4个职业霍兰德代码及匹配情况为：</p>
          <ul class="label-box">
            <li class="career-label" v-for="(item,index) in cosCareer.listCareer">
              <p class="label-name">{{item.careerName}}</p>
              <p>霍兰德代码：<span class="label-score">{{item.hollandPreThree}}</span></p>
              <p>你与该职位的匹配度：</p>
              <p class="label-score">{{item.iTotalScore}}%</p>
            </li>
          </ul>
        </div>
        <p class="tip">想查看全部职业的霍兰德代码，或与我的匹配度，<span @click="handleClick">点此</span></p>
      </div>
      <FootBox :id="id"/>
    </div>
    <div v-else>
      <CareerSearch :id="id" v-on:listenToChildEvent="handleBackHere"/>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import CareerSearch from '@/page/CareerSearch.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'

export default {
  props: {
    id: Number
  },
  name: 'CareerMatchReport',
  components: {
    HeaderBox,
    FootBox,
    CareerSearch
  },
  data() {
    return {
      cosCareer:'',
      enterCareerSearch: false
    }
  },
	computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
	},
  created: function () {
    setWechatTitle('生涯驿站-职业倾向匹配')
    this.getReport()
  },
  methods:{
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosMatchReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data
            if(Result){
              this.cosCareer=Result.cosCareer
              // 弹幕
              let num = Math.round(Math.random()*3),
              text = '选择的'+this.cosCareer.listCareer[num].careerName+'-职业代码居然是'+this.cosCareer.listCareer[num].hollandPreThree
              store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
            }
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    },
    handleClick(){
      this.enterCareerSearch = true
    },
    handleBackHere() {
      this.enterCareerSearch = false
    }
  }
}
</script>
<style lang="stylus" scoped>
  .tip
    width: 100%
    max-width: 12rem
    text-align:center
    position: fixed
    bottom: 1.3rem
    span
      color:#DC6E5A
      font-weight:bold
      cursor:pointer
  .label-box
    overflow:hidden
    .career-label
      float:left
      width:50%
      background-color:#FF7F00
      p
        color:#ffffff
        text-align:center
        marign:0.2rem auto
      .label-name
        font-size:0.36rem
        height: 1.2rem
        display: flex
        display: -webkit-flex
        justify-content: center
        align-items: center
        -webkit-align-items: center
      .label-score
        font-size:0.56rem
    .career-label:nth-child(2)
      background-color:#7DB0DF
    .career-label:nth-child(3)
      background-color:#C1D659
    .career-label:nth-child(4)
      background-color:#F3A772
</style>
